export const SET_VALIDATION_ERROR = "SET_VALIDATION_ERROR";
export const RESET_VALIDATION_ERROR = "RESET_VALIDATION_ERROR";